import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { Link } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import ArticleCard from '@components/Blogs/ArticleCard';
import SharePost from '@components/Blogs/SharePost';
import SearchArticle from '@components/Blogs/SearchArticle';
import { DispatchContext } from '@store/store';
import { openAuthModal } from '@store/actions';
import API from '@lib/API';

// TODO: Complete Commenting System
// import CommentForm from '@components/Blogs/CommentForm';
// import Comments from '@components/Blogs/Comments';
// import RecentPosts from '@components/Blogs/RecentPosts';
const AuthAPI = new API();

function BlogBottom(props) {
  const {
    path,
    slugPrefix,
    prev,
    next,
    latestBlogs,
    language,
    isLoggedIn,
  } = props;
  const dispatch = useContext(DispatchContext);

  const { t } = useTranslation();

  const onEditVideo = () => {
    sessionStorage.setItem('blogSignupClicked', 'true');
    AuthAPI.sendAmplitudeEvent('Click Signup', {
      btnPosition: 'Blog Page - Bottom',
    });
    dispatch(openAuthModal({ tab: 'signup' }));
  };

  const onCommunityClick = () => {
    AuthAPI.sendAmplitudeEvent('Click Join FB Group', {
      btnPosition: 'Blog Page - Bottom',
    });
  };

  return (
    <BlogBottomContainer>
      {isLoggedIn ? (
        <div className="box-button bg-brandPrimary">
          <span className="left pr-0 md:pr-4">{t('blog:fbBanner')}</span>
          <div className="right">
            <a
              href="https://bit.ly/3DRGxc6"
              rel="noopener noreferrer"
              className="inline-block text-brandPrimary"
              target="_blank"
              onClick={onCommunityClick}
            >
              {t('blog:joinfb')}
            </a>
          </div>
        </div>
      ) : (
        <div className="box-button bg-brandPrimary">
          <span className="left pr-0 md:pr-4">{t('blog:editVideoText')}</span>
          <div className="right">
            <a
              href="javascript:void(0)"
              rel="noopener noreferrer"
              className="inline-block text-brandPrimary"
              onClick={onEditVideo}
            >
              {t('blog:editVideo')}
            </a>
          </div>
        </div>
      )}
      <SharePost slug={path} />
      <ul className="flex flex-wrap justify-between list-none p-0 my-4">
        <li className="w-1/2 p-2">
          {prev && (
            <Link
              to={`${slugPrefix}${prev.Slug}/`}
              rel="prev"
              className="text-black"
            >
              {prev.Title}
              <span className="block my-2 text-sm text-gray-600">
                Previous Post
              </span>
            </Link>
          )}
        </li>
        <li className="w-1/2 p-2 text-right">
          {next && (
            <Link
              className="text-black"
              to={`${slugPrefix}${next.Slug}/`}
              rel="next"
            >
              {next.Title}
              <span className="block my-2 text-gray-600 text-sm text-right">
                Next Post
              </span>
            </Link>
          )}
        </li>
      </ul>

      <SearchArticle />

      {Array.isArray(latestBlogs) && latestBlogs.length > 0 && (
        <div>
          <h3 className="my-4 px-4 text-xl">{t('blog:latestArticles')}</h3>

          <div className="flex flex-wrap">
            {latestBlogs.map(({ node }) => (
              <ArticleCard
                node={node}
                key={`article${node.id}`}
                featureImage={
                  node.fields?.posterImage?.medium?.url ||
                  node.FeatureImage?.url
                }
                slugPrefix={slugPrefix}
                language={language}
              />
            ))}
          </div>
        </div>
      )}

      {/* <Comments /> */}
      {/* <CommentForm /> */}
      {/* <RecentPosts t={t} /> */}
    </BlogBottomContainer>
  );
}

export default BlogBottom;

const BlogBottomContainer = styled.section`
  max-width: 912px;
  margin: 1rem auto;

  .box-button {
    padding: 20px;
    color: #fff;
    margin: 5px auto;
    border-radius: 5px;
    text-align: center;
    width: 100%;
    display: grid;
    grid-template-columns: 3fr 1fr;
    align-items: center;

    @media (max-width: 450px) {
      grid-template-columns: 1fr;

      .right {
        margin-top: 1rem;
      }
    }

    .left {
      text-align: left;
    }

    .right a {
      border-radius: 5px;
      background-color: #fff;
      padding: 5px 15px;
      font-weight: 600;
      font-size: 14px;
    }
  }
`;
